export const API_URL = process.env.REACT_APP_API_URL;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;

export const END_POINTS = {
  login: "/vendor/onboarding/login",
  forgotPassword: "/vendor/onboarding/send-otp",
  sendOtp: "/vendor/onboarding/send-otp",
  verifyOtp: "/vendor/onboarding/verify-otp",
  resetPassword: "/vendor/onboarding/change-password",
  changePassword: "/vendor/onboarding/change-password",
  updateProfile: "/vendor/add",
  logout: "user/logout",
  upload: "/vendor/media",
  getProfile: "/vendor",
  myProfile: "/vendor/onboarding",
  editMyProfile: "/vendor/onboarding/update",

  //category
  category: "/vendor/category",

  //product
  product: "/vendor/product",
  editVariant: "/vendor/product/variant",
  attribute: "/vendor/category/attributes/category",
  productVariants: "/vendor/product/variants/all",
  changeProductStatus: "/vendor/product/toggle",

  // cms
  getCms: "/vendor/cms",
  getFaq: "/vendor/cms/faq",

  //orders
  orders: "/order/user",
};
